import type { Kaufplan, Einstieg } from './kaufplan.types'

// Stand 30.10.2026 (Schlusskurse, Einzelaktien am 31.10. nachgezogen). Quellen siehe `quellen` am Ende.
// Abstand vom 52W-Hoch: eigene Berechnung aus Yahoo-Tageshochs der letzten 12 Monate.

const etfs: Einstieg[] = [
  { name: 'MSCI World', ticker: 'IWDA / URTH', typ: 'etf', bereich: 'Welt, Kern', kurs: '$204.64', vomHoch: -3.4, kgv: 'Fwd 17.8',
    urteil: 'staffeln', kaufzone: 'T1 jetzt, Rest nach Tranchenplan',
    invalidierung: 'HY-Spread > 4.5% und S&P < 6 650 → Pause',
    warum: 'Kern jedes Portfolios. Nur 3% unter Hoch, deshalb nicht alles auf einmal — aber auch nicht warten, bis es "billig" ist.' },
  { name: 'S&P 500', ticker: 'CSPX / SPY', typ: 'etf', bereich: 'USA Large Caps', kurs: '$755.72', vomHoch: -3.3, kgv: 'Fwd 18.7 · CAPE ~41',
    urteil: 'warten', kaufzone: 'S&P ≤ 7 300 (200-Tage-Linie)',
    invalidierung: '10Y wieder > 5.3% → Gewicht nicht erhöhen',
    warum: 'Fwd-KGV unter 5J-Schnitt, aber CAPE nahe Rekord und Risikoprämie ~0. BlackRock hat US-Aktien auf Neutral gesenkt. Über den World-ETF reicht es.' },
  { name: 'Nasdaq 100', ticker: 'EQQQ / QQQ', typ: 'etf', bereich: 'USA Tech', kurs: '$690.49', vomHoch: -9.5, kgv: 'KGV ttm 26.4',
    urteil: 'staffeln', kaufzone: 'QQQ 640–690 in 3 Teilen',
    invalidierung: 'QQQ < 620 (≈ −19%) → nicht weiter nachkaufen',
    warum: 'Fast eine 10%-Korrektur, Short-Interest auf Hoch seit 2023 — Treibstoff für Erholung. Aber Capex-Schock (Alphabet, Amazon) ist nicht verdaut.' },
  { name: 'Halbleiter', ticker: 'SMH', typ: 'etf', bereich: 'Chips / KI', kurs: '$522.49', vomHoch: -22.2, kgv: 'Fwd 16.6',
    urteil: 'kaufen', kaufzone: '$470–525, Drittel vor und nach Nvidia (17.11.)',
    invalidierung: 'Nvidia senkt Ausblick oder SMH < $440',
    warum: 'Grösster Rabatt bei Qualität: −22% und Fwd-KGV 16.6 — günstiger als der S&P 500. Bärenmarkt im Sektor, aber die Gewinne wachsen weiter.' },
  { name: 'S&P 500 Equal Weight', ticker: 'XDEW / RSP', typ: 'etf', bereich: 'USA breit', kurs: '$218.31', vomHoch: -2.3, kgv: 'Fwd 16.6',
    urteil: 'staffeln', kaufzone: '$205–218',
    invalidierung: 'Marktbreite kippt (RSP fällt mit Tech)',
    warum: 'Die Breite hält: am 29.10. stiegen 403 von 500 Titeln. Gleichgewichtung = weniger KI-Klumpenrisiko, KGV 16.6.' },
  { name: 'Schwellenländer', ticker: 'EIMI / EEM', typ: 'etf', bereich: 'EM', kurs: '$61.04', vomHoch: -14.7, kgv: 'Fwd 8.6',
    urteil: 'kaufen', kaufzone: '$57–61',
    invalidierung: 'Dollar (DXY) wieder > 105',
    warum: 'Billigster grosser Markt der Welt (KGV 8.6), schwächerer Dollar hilft. BlackRock übergewichtet EM seit 26.10.' },
  { name: 'Russell 2000', ticker: 'IWM', typ: 'etf', bereich: 'USA Small Caps', kurs: '$279.33', vomHoch: -8.5, kgv: 'Fwd 14.1',
    urteil: 'warten', kaufzone: 'Erst wenn Fed-Hike vom Tisch',
    invalidierung: '—',
    warum: 'Günstig, aber Small Caps leiden am meisten unter 5% Zinsen und Refinanzierung. Dezember-Hike zu ~74% eingepreist.' },
  { name: 'Europa', ticker: 'MEUD / VGK', typ: 'etf', bereich: 'Europa', kurs: '$87.54', vomHoch: -6.2, kgv: 'KGV ttm 17.4',
    urteil: 'warten', kaufzone: 'Nach EZB-Dezember / OAT-Entspannung',
    invalidierung: '—',
    warum: 'Inflation 3.8%, mögliche EZB-Erhöhung im Dezember, französische 10J-Rendite > 5%, Lagarde tritt im Februar ab. Zu viel Unsicherheit.' },
  { name: 'Japan', ticker: 'EWJ', typ: 'etf', bereich: 'Japan', kurs: '$92.91', vomHoch: -7.1, kgv: 'KGV ttm 14.6',
    urteil: 'warten', kaufzone: 'Nikkei-Rücksetzer > 10%',
    invalidierung: '—',
    warum: 'Solide, aber Yen bei 157 und Nikkei −2.1% am 30.10. — kein klarer Vorteil gegenüber EM.' },
  { name: 'Indien', ticker: 'INDA', typ: 'etf', bereich: 'Indien', kurs: '$47.72', vomHoch: -13.4, kgv: 'KGV ttm 21.8',
    urteil: 'warten', kaufzone: 'KGV < 19',
    invalidierung: '—',
    warum: 'YTD −11.7%, trotzdem KGV 21.8 — teurer als der Rest der EM. Öl $117 trifft Indien als Importeur direkt.' },
  { name: 'China', ticker: 'MCHI', typ: 'etf', bereich: 'China', kurs: '$49.07', vomHoch: -24.9, kgv: 'KGV ttm 10.7',
    urteil: 'warten', kaufzone: 'Erst nach Bodenbildung',
    invalidierung: '—',
    warum: 'Schwächster Monat seit über 10 Jahren, nahe 52W-Tief. Billig, aber fallendes Messer — über den EM-ETF ist man bereits dabei.' },
  { name: 'Gesundheit', ticker: 'XLV', typ: 'etf', bereich: 'USA defensiv', kurs: '$184.87', vomHoch: -1.7, kgv: 'KGV ttm 33.0',
    urteil: 'staffeln', kaufzone: '$175–185',
    invalidierung: '—',
    warum: 'Defensiver Gewinner der Rotation (YTD +19%). Puffer gegen Tech-Schwankung, aber nicht billig.' },
  { name: 'Energie', ticker: 'XLE', typ: 'etf', bereich: 'Öl & Gas', kurs: '$70.02', vomHoch: 0.0, kgv: 'Fwd 11.8',
    urteil: 'warten', kaufzone: 'Rücksetzer auf $62–65',
    invalidierung: 'Waffenruhe Hormus → Öl fällt schnell',
    warum: 'YTD +57%, am Hoch. Wer hat: halten als Öl-Versicherung. Nicht hinterherjagen.' },
  { name: 'Versorger', ticker: 'XLU', typ: 'etf', bereich: 'USA defensiv', kurs: '$43.43', vomHoch: -9.1, kgv: 'n/a',
    urteil: 'warten', kaufzone: 'Wenn 10Y < 4.5%',
    invalidierung: '—',
    warum: 'Zinssensitiv — solange die Fed eher erhöht, kein Rückenwind.' },
  { name: 'Gold', ticker: 'GLD / phys.', typ: 'etf', bereich: 'Edelmetall', kurs: '$355.78 · Spot $3 899', vomHoch: -30.2, kgv: '—',
    urteil: 'warten', kaufzone: 'Erst wenn Spot wieder > $4 100',
    invalidierung: '—',
    warum: 'Ein-Jahres-Tief, 13.5% unter 200T. Margin-Call-Verkäufe und Zinsangst — Gold hat 2026 nicht geschützt. Fallendes Messer.' },
  { name: 'Uran', ticker: 'URA', typ: 'etf', bereich: 'Rohstoff', kurs: '$33.73', vomHoch: -45.8, kgv: 'n/a',
    urteil: 'warten', kaufzone: 'Nach Bodenbildung über $36',
    invalidierung: '—',
    warum: '−46% und nahe 52W-Tief. Langfristthese (KI-Strom) intakt, aber der KI-Finanzierungsstress trifft genau dieses Segment.' },
  { name: 'Rüstung Europa', ticker: 'EUAD', typ: 'etf', bereich: 'Rüstung', kurs: '$39.54', vomHoch: -18.4, kgv: 'KGV ttm 26.4',
    urteil: 'warten', kaufzone: 'KGV < 22',
    invalidierung: '—',
    warum: '−18%, aber immer noch KGV 26. Budget-These bekannt und eingepreist.' },
  { name: 'Treasuries 20+ Jahre', ticker: 'IDTL / TLT', typ: 'etf', bereich: 'Lange US-Anleihen', kurs: '$81.84', vomHoch: -9.9, kgv: 'Rendite 5.0%',
    urteil: 'meiden', kaufzone: '—',
    invalidierung: 'Inflation < 3% → neu prüfen',
    warum: 'Schützt 2026 nicht: Aktien/Anleihen-Korrelation +0.42. Inflation 3.6% und Hike-Risiko drücken auf lange Laufzeiten.' },
  { name: 'Kurze Treasuries / Geldmarkt', ticker: 'IB01 / SGOV', typ: 'etf', bereich: 'Cash-Parkplatz', kurs: '$100.73', vomHoch: 0.0, kgv: 'Rendite 3.7%',
    urteil: 'kaufen', kaufzone: 'Für alle noch nicht investierten Tranchen',
    invalidierung: '—',
    warum: 'Parkplatz mit Zins, kein Kursrisiko. Für CHF-Anleger: CHF-Geldmarkt (Zins tiefer, aber kein Währungsrisiko).' },
]

const aktien: Einstieg[] = [
  // ── Kaufen / staffeln: Qualität, die mitgefallen ist ──
  { name: 'Microsoft', ticker: 'MSFT', typ: 'aktie', bereich: 'Cloud / KI', kurs: '$521.91', vomHoch: -5.3, kgv: 'n/a',
    urteil: 'kaufen', kaufzone: '$495–525, in 2 Teilen',
    invalidierung: 'Azure-Wachstum < 35%',
    warum: 'Bestes Q3 der Hyperscaler: Azure +48%, Capex unter Erwartung, "Nachfrage übersteigt Angebot". Risiko: ~45% des Auftragsbestands hängt an OpenAI.' },
  { name: 'Meta Platforms', ticker: 'META', typ: 'aktie', bereich: 'Werbung / KI', kurs: '$614.99', vomHoch: -21.1, kgv: 'n/a',
    urteil: 'kaufen', kaufzone: '$580–630',
    invalidierung: 'Capex-Ausblick 2027 > $180 Mrd.',
    warum: 'Umsatz +26%, starke Q4-Guidance, 21% unter Hoch. Die Werbung finanziert die KI selbst — anders als bei den Neoclouds.' },
  { name: 'NVIDIA', ticker: 'NVDA', typ: 'aktie', bereich: 'Chips / KI', kurs: '$204.64', vomHoch: -15.9, kgv: 'Fwd 22.7',
    urteil: 'staffeln', kaufzone: '$195–210 (200T ~$204); 2. Teil nach 17.11.',
    invalidierung: 'Schluss < $185 oder Guidance-Senkung',
    warum: '16% unter Rekord, schwächster Monat seit Nov 2025. Schluss 30.10. knapp über der 200-Tage-Linie ($204.4). Umsatz +106%. Zahlen am 17.11. entscheiden.' },
  { name: 'TSMC', ticker: 'TSM', typ: 'aktie', bereich: 'Chips / Foundry', kurs: '$406.13', vomHoch: -16.7, kgv: 'n/a',
    urteil: 'staffeln', kaufzone: 'Bei jedem Sektor-Abverkauf −5%',
    invalidierung: 'Bruttomarge < 60%',
    warum: 'Q3 über eigener Guidance, Bruttomarge 66%, Q4-Guidance $52–54 Mrd. Der Engpass der ganzen KI-Kette — verdient egal, wer gewinnt.' },
  { name: 'ASML', ticker: 'ASML', typ: 'aktie', bereich: 'Chip-Ausrüster', kurs: '$1 565.90 (ADR)', vomHoch: -21.7, kgv: 'n/a',
    urteil: 'staffeln', kaufzone: 'In 3 Teilen über 6 Wochen',
    invalidierung: 'Auftragseingang Q4 bricht ein',
    warum: 'Q4-Guidance €14–15 Mrd., erste Aufträge für 2028. Europäischer Qualitätswert, der im Chip-Sog mitfällt.' },
  { name: 'Alphabet', ticker: 'GOOGL', typ: 'aktie', bereich: 'Suche / Cloud', kurs: '$279.84', vomHoch: -31.5, kgv: 'n/a',
    urteil: 'staffeln', kaufzone: '1/3 jetzt, Rest erst nach Schluss > $280',
    invalidierung: 'Free Cashflow Q4 erneut negativ',
    warum: 'Schlechtester Tag der Firmengeschichte (−12.6%). Cloud +103%, Umsatz +25%. Das Problem ist der Free Cashflow (−$9 Mrd.) durch $200 Mrd. Capex. Schluss 30.10. knapp unter $280, RSI 21 — überverkauft. Berkshire hält $10 Mrd.' },
  { name: 'SAP', ticker: 'SAP', typ: 'aktie', bereich: 'Software Europa', kurs: '$235.02 (ADR)', vomHoch: -11.6, kgv: 'n/a',
    urteil: 'staffeln', kaufzone: 'Rücksetzer Richtung $220',
    invalidierung: 'Cloud-Backlog-Wachstum < 20%',
    warum: 'Erstmals > €10 Mrd. Quartalsumsatz, Cloud +26%, Backlog +28%. Wachstum verlangsamt sich leicht.' },

  // ── Warten ──
  { name: 'AMD', ticker: 'AMD', typ: 'aktie', bereich: 'Chips', kurs: '$504.80', vomHoch: -23.3, kgv: 'n/a',
    urteil: 'warten', kaufzone: 'Nach Zahlen am 3.11.',
    invalidierung: '—',
    warum: '−10% an einem Tag ohne eigene News. Optionen preisen ±11% für die Zahlen ein — nicht vorher wetten.' },
  { name: 'Broadcom', ticker: 'AVGO', typ: 'aktie', bereich: 'Chips / Netzwerk', kurs: '$326.08', vomHoch: -34.1, kgv: 'n/a',
    urteil: 'warten', kaufzone: 'Nach Zahlen im Dezember',
    invalidierung: '—',
    warum: 'Der CEO warnt selbst: Kapital ist der Engpass ("Casino"). Wenn das Management bremst, nicht vorauslaufen.' },
  { name: 'Amazon', ticker: 'AMZN', typ: 'aktie', bereich: 'Handel / Cloud', kurs: '$240.35', vomHoch: -16.3, kgv: 'n/a',
    urteil: 'warten', kaufzone: 'Wenn Free Cashflow dreht',
    invalidierung: '—',
    warum: 'Q3 verfehlt, Capex $77 Mrd. statt $59 Mrd., zweites Quartal in Folge negativer Free Cashflow.' },
  { name: 'UnitedHealth', ticker: 'UNH', typ: 'aktie', bereich: 'Gesundheit', kurs: '$406.97', vomHoch: -11.8, kgv: 'n/a',
    urteil: 'warten', kaufzone: 'Nach Ausblick 2027 (Dezember)',
    invalidierung: '—',
    warum: 'Erholung bestätigt (EPS-Beat, Guidance hoch, +11% in einer Woche). Die Chance ist schon gelaufen, Ausblick 2027 abwarten.' },
  { name: 'Eli Lilly', ticker: 'LLY', typ: 'aktie', bereich: 'Pharma', kurs: '$1 417.54', vomHoch: -2.2, kgv: 'n/a',
    urteil: 'warten', kaufzone: 'Erst bei 10–15% Rücksetzer',
    invalidierung: '—',
    warum: 'Umsatz +39%, Guidance angehoben — operativ top, aber nicht gefallen. Kein Rabatt, kein Grund zur Eile.' },
  { name: 'JPMorgan', ticker: 'JPM', typ: 'aktie', bereich: 'Banken', kurs: '$337.04', vomHoch: -8.0, kgv: 'n/a',
    urteil: 'warten', kaufzone: 'Nach Kreditstress-Test',
    invalidierung: '—',
    warum: 'EPS verfehlt, Zinsüberschuss-Ausblick angehoben. Solide, aber Private-Credit-Stress kann auf Banken übergreifen.' },
  { name: 'Exxon Mobil', ticker: 'XOM', typ: 'aktie', bereich: 'Öl', kurs: '$187.25', vomHoch: -0.7, kgv: 'n/a',
    urteil: 'warten', kaufzone: 'Halten, nicht nachkaufen',
    invalidierung: 'Waffenruhe Hormus',
    warum: 'Q3-Beat, $19 Mrd. Free Cashflow. Gute Öl-Versicherung im Depot, aber nahe Hoch.' },
  { name: 'LVMH', ticker: 'MC', typ: 'aktie', bereich: 'Luxus', kurs: '€387.00', vomHoch: -40.9, kgv: 'n/a',
    urteil: 'warten', kaufzone: 'Erst bei China-Wende',
    invalidierung: '—',
    warum: 'Nahe 6-Jahres-Tief, aber Mode/Leder −5% organisch. Billig allein reicht nicht.' },

  // ── Meiden ──
  { name: 'Intel', ticker: 'INTC', typ: 'aktie', bereich: 'Chips', kurs: '$65.76', vomHoch: -53.8, kgv: 'n/a',
    urteil: 'meiden', kaufzone: '—',
    invalidierung: '—',
    warum: '−29% an einem Tag, schwache Q4-Guidance, 2027 kein positiver Free Cashflow, PC-Markt −12%.' },
  { name: 'CoreWeave', ticker: 'CRWV', typ: 'aktie', bereich: 'KI-Rechenzentren', kurs: '$54.87', vomHoch: -60.3, kgv: 'n/a',
    urteil: 'meiden', kaufzone: '—',
    invalidierung: '—',
    warum: 'CDS 1 145bp, Anleihen rentieren ~15%, Free Cashflow −$10 Mrd. Der Kreditmarkt preist Notlage ein.' },
  { name: 'Palantir', ticker: 'PLTR', typ: 'aktie', bereich: 'Software', kurs: '$184.11', vomHoch: -13.5, kgv: 'Fwd ~98',
    urteil: 'meiden', kaufzone: '—',
    invalidierung: '—',
    warum: 'Fwd-KGV ~98 bei 5% Zinsen. Jede Enttäuschung kostet 30%+.' },
]

export const kaufplan: Kaufplan = {
  tacheles: {
    stand: '2026-10-31',
    urteil: 'Kein All-in, keine Panik: Der breite Markt ist kaum billiger. Rabatte gibt es bei Chips und Schwellenländern. Dort gestaffelt kaufen, den Rest in kurzen Anleihen parken.',
    score: 38,
    scoreLabel: 'ANGST',
    punkte: [
      'S&P 500 nur −3.1% vom Rekord, Shiller-CAPE ~41: Ein Einmalkauf in US-Large-Caps lohnt sich nicht.',
      'Die echten Rabatte: Halbleiter −22% (Fwd-KGV 16.6), Schwellenländer −15% (KGV 8.6), Nasdaq 100 −9.5%. Dort einsteigen, in Tranchen.',
      'Rückenwind: Q3-Gewinne +30% mit 82% Beats, Fwd-KGV 18.7 unter dem 5J-Schnitt. Nach der Midterm-Wahl war der S&P 500 12 Monate später 19 von 19 Mal im Plus.',
      'Gegenwind: Brent $117.64 (+13.6% im Oktober), Dezember-Hike zu ~74% eingepreist, KI-Kreditstress (CoreWeave-CDS > 1 100bp). Deshalb 20% Cash-Puffer.',
      'Keine Blase, aber ein Regime im Umbruch: Blasen-Score 3 von 15 (normal), 60% der S&P-Titel über der 50-Tage-Linie. Das Makro-Regime steht im Übergang (49.5/100), Energie ist überkauft, Versorger sind überverkauft.',
      'Szenarien bis April 2028: Basis 45% (ein Hike, holprige Entspannung, S&P 7 600–8 500), Bull 20%, Bär 35% — davon 20% zähe Stagflation ohne Rezession (S&P 6 450–7 000). Gewichtet liegt der S&P in 12 Monaten bei ~7 430, also leicht unter heute.',
      'Anleihen schützen 2026 nicht: Aktien und Treasuries korrelieren mit +0.42. Lange Laufzeiten meiden, Puffer nur in kurzen Laufzeiten bzw. Geldmarkt.',
    ],
  },

  kennzahlen: [
    { label: 'S&P 500', wert: '7 580', delta: '−3.1% v. Hoch', ton: 'neg' },
    { label: 'Nasdaq',  wert: '25 437', delta: '−7.8% v. Hoch', ton: 'neg' },
    { label: 'VIX',     wert: '19.4',  delta: '+12.9% am 30.10.', ton: 'neutral' },
    { label: '10Y US',  wert: '4.93%', delta: '−14bp s. 16.10.', ton: 'pos' },
    { label: 'Brent',   wert: '$117',  delta: '+11% s. 16.10.', ton: 'neg' },
    { label: 'Gold',    wert: '$3 899', delta: '1-Jahres-Tief', ton: 'neg' },
  ],

  spxAktuell: 7580,
  spxHoch:    7819,
  tranchen: [
    { nr: 1, anteil: 25, trigger: 'Jetzt (vor Midterms 3.11.)', spxLevel: 7580, status: 'jetzt',
      was: 'MSCI World + erste SMH- und EM-Tranche' },
    { nr: 2, anteil: 20, trigger: 'S&P ≤ 7 300 (200-Tage-Linie ~7 310, −6.6% v. Hoch)', spxLevel: 7300, status: 'offen',
      was: 'MSCI World, Equal Weight, Nasdaq 100' },
    { nr: 3, anteil: 20, trigger: 'S&P ≤ 7 040 (−10% Korrektur)', spxLevel: 7040, status: 'offen',
      was: 'Nasdaq 100, SMH, Qualitäts-Einzelaktien' },
    { nr: 4, anteil: 15, trigger: 'S&P ≤ 6 650 (−15%)', spxLevel: 6650, status: 'offen',
      was: 'Breit nachkaufen, nur wenn HY-Spread < 4.5%' },
    { nr: 5, anteil: 20, trigger: 'Zeit-Stopp gestaffelt: Hälfte nach FOMC 9.12., Rest nach FOMC Ende Jan. 2027', spxLevel: null, status: 'offen',
      was: 'Alles noch nicht Investierte in den Kern. Ausnahme: Wochenschluss S&P < 200-Tage-Linie (~7 310) plus HY-Spread > 4.5% — dann T4 scharf lassen' },
  ],

  einstiege: [...etfs, ...aktien],

  korrelation: {
    hinweis: 'Seit 2022 fallen Aktien und Anleihen oft gemeinsam. Bei 3.5% Inflation sind lange Treasuries kein Schutz. Gold lief 2026 ebenfalls mit Aktien mit (+0.35) und hat im Abverkauf nicht geschützt. Echte Puffer: Cash und Kurzläufer. Halbleiter sind praktisch derselbe Trade wie der Nasdaq (0.88), also nicht doppelt gewichten.',
    paare: [
      { paar: 'S&P 500 ↔ 10J-Treasuries', wert: 0.42,  fenster: '2026 YTD (bis 7.8.), täglich', quelle: 'dataporium.tech (FRED)' },
      { paar: 'SPY ↔ TLT (kurzfristig)',   wert: -0.24, fenster: '20 Tage, 23.10.2026',          quelle: 'Lead-Lag Report' },
      { paar: 'S&P 500 ↔ Gold',            wert: 0.35,  fenster: '90 Tage, Aug 2026',            quelle: 'convextrade' },
      { paar: 'S&P 500 ↔ Bitcoin',         wert: 0.68,  fenster: '30 Tage, 2026',                quelle: 'Newhedge / CoinCentral' },
      { paar: 'Nasdaq 100 ↔ Halbleiter',   wert: 0.88,  fenster: '1 Jahr täglich, 14.9.2026',    quelle: 'ClearAnk (QQQ/SOXX)' },
      { paar: 'Gold ↔ Realzins',           wert: -0.23, fenster: '2026 YTD',                     quelle: 'convextrade' },
      { paar: 'US-Dollar ↔ Gold',          wert: -0.45, fenster: '60 Tage, Ø seit 2022',         quelle: 'CME via Substack' },
      { paar: 'Bitcoin ↔ US-Dollar',       wert: -0.90, fenster: '30 Tage, Apr 2026',            quelle: 'CoinDesk' },
    ],
    aktienAnleihen: [
      { jahr: '2016–21', wert: -0.36 },
      { jahr: '2022',    wert: 0.18 },
      { jahr: '2023',    wert: 0.07 },
      { jahr: '2024',    wert: 0.06 },
      { jahr: '2025',    wert: -0.13 },
      { jahr: '2026',    wert: 0.42 },
    ],
    aaQuelle: 'dataporium.tech, S&P 500 vs. 10Y-Preisproxy (FRED SP500/DGS10), 2026 bis 7.8.',
  },

  nachKorrektur: {
    titel: 'S&P 500: Ø Rendite 12 Monate nach … (Tooltip: Trefferquote)',
    quelle: 'Schaeffer’s 04/2026, Innovator/Bloomberg 1949–2025, StoneX, Opening Bell Daily 1950–2022',
    daten: [
      { label: 'Basis: beliebiger Tag',          rendite12: 10.65, positiv12: 71,  quelle: 'Schaeffer’s Research' },
      { label: 'Erster −10% vom Rekord',         rendite12: 6.2,   positiv12: 57,  quelle: 'Schaeffer’s Research' },
      { label: '10%-Korrektur',                  rendite12: 15.7,  positiv12: 80,  quelle: 'Innovator / Bloomberg, 1949–2025' },
      { label: 'VIX-Schluss > 30',               rendite12: 22.3,  positiv12: 88,  quelle: 'StoneX (überlappende Tage)' },
      { label: 'Nach Midterm-Wahl',              rendite12: 15.1,  positiv12: 100, quelle: 'Opening Bell Daily, 19 von 19 seit 1950' },
    ],
  },

  saison: {
    titel: 'S&P 500: Ø Monatsrendite 1950–2025 — Nov/Dez sind die stärksten Monate',
    quelle: 'Opening Bell Daily, Kursrendite 1950–2025',
    daten: [
      { monat: 'Jan', wert: 1.1 }, { monat: 'Feb', wert: 0.0 }, { monat: 'Mär', wert: 1.0 },
      { monat: 'Apr', wert: 1.4 }, { monat: 'Mai', wert: 0.4 }, { monat: 'Jun', wert: 0.2 },
      { monat: 'Jul', wert: 1.3 }, { monat: 'Aug', wert: 0.0 }, { monat: 'Sep', wert: -0.6 },
      { monat: 'Okt', wert: 0.9 }, { monat: 'Nov', wert: 1.9 }, { monat: 'Dez', wert: 1.4 },
    ],
  },

  erp: {
    quelle: 'Damodaran (2000–2008), Benzinga (Jan 2025), eigene Berechnung 30.10.2026 (FactSet Fwd-KGV 18.7, 10Y 4.93%); * = Schätzung',
    daten: [
      { label: '2000',     wert: -1.2 },
      { label: '2007',     wert: 1.6 },
      { label: '2008',     wert: 5.0 },
      { label: '2021*',    wert: 3.1 },
      { label: '2024*',    wert: 0.0 },
      { label: 'Jan 2025', wert: -0.75 },
      { label: 'Okt 2026', wert: 0.42 },
    ],
  },

  allokation: [
    { name: 'Welt-Aktien (Kern)',      anteil: 40, inhalt: 'MSCI World / FTSE All-World, plus Equal Weight' },
    { name: 'Cash & kurze Anleihen',   anteil: 20, inhalt: 'Geldmarkt CHF/USD, 0–1J-Treasuries — Munition für die Tranchen' },
    { name: 'Halbleiter & KI-Qualität', anteil: 10, inhalt: 'SMH oder TSMC/ASML/Nvidia, je ≤ 3%' },
    { name: 'Schwellenländer',         anteil: 10, inhalt: 'MSCI EM — billigster grosser Markt' },
    { name: 'Schweiz / Europa Qualität', anteil: 10, inhalt: 'SMI-Defensive (Pharma, Nahrung), Finanzen' },
    { name: 'Realwerte',               anteil: 10, inhalt: 'Energie als Öl-Hedge, Gold erst nach Stabilisierung' },
  ],

  risiken: [
    { titel: 'Öl-Schock eskaliert', text: 'Mehrere Tanker in Hormus auf Minen gelaufen, Huthi-Angriff auf Ras Tanura (550 kb/d) am 27.10., nur noch ~4 statt ~85 Durchfahrten pro Tag. Trump knüpft das Kriegsende an die Zeit nach den Midterms. Selbst nach einem Deal dauert die Minenräumung 3–6 Monate.', signal: 'Brent > $130 → Tranchen 3–4 pausieren' },
    { titel: 'Zähe Stagflation', text: 'Kein Deal, Brent bleibt bei $100–125, die Fed erhöht bis 4.50%, aber keine Rezession. Der S&P fiele um 8–15%. Laut Szenario-Analyse das wahrscheinlichste Negativ-Szenario (20%).', signal: 'Kern-PCE ≥ 3.4% oder Dezember-Dots mit ≥ 2 Hikes → T4 nicht vorzeitig abbauen' },
    { titel: 'Fed erhöht im Dezember', text: 'PCE 3.6%, Kern 3.1%, BIP Q3 +3.4% — die Fed hat keinen Grund zu lockern. Zwei Mitglieder wollten bereits im Oktober erhöhen.', signal: '10Y > 5.3% → keine US-Large-Caps nachkaufen' },
    { titel: 'KI-Capex-Kater', text: 'Alphabet −12.6% an einem Tag, Amazon-Capex $77 Mrd. statt $59 Mrd., Intel −28%. Der Markt bestraft Ausgaben ohne sofortigen Cashflow.', signal: 'Nvidia-Ausblick 17.11. entscheidet über SMH-Tranche 2' },
    { titel: 'Kreditstress springt über', text: 'CoreWeave-CDS 1 145bp, der HY-Primärmarkt pausiert. HY-Spread von 2.7% (Aug) auf 3.3–3.4% gestiegen.', signal: 'HY-Spread > 4.5% → T4 nicht auslösen' },
    { titel: 'Gewinnklippe 2027', text: 'Für Q2 2027 werden nur +2.8% Gewinnwachstum erwartet, nach +30% heute. Das Fwd-KGV sieht günstiger aus, als es ist.', signal: 'Sinkende 2027er Schätzungen bei FactSet' },
    { titel: 'Europa-Anleihen', text: 'Französische 10J-Rendite erstmals seit 2002 > 5%, OAT-Bund-Spread 160bp, Lagarde tritt vorzeitig ab.', signal: 'Spread > 200bp → Europa weiter meiden' },
  ],

  termine: [
    { datum: '2026-11-01', label: 'OPEC+-Treffen (Nov-Quote gehalten)', wichtig: false },
    { datum: '2026-11-02', label: 'Apple Q4-Zahlen nach Börsenschluss (±4.5% eingepreist)', wichtig: false },
    { datum: '2026-11-03', label: 'US-Midterm-Wahlen; AMD-Zahlen', wichtig: true },
    { datum: '2026-11-04', label: 'Euroraum HVPI Schnellschätzung Oktober', wichtig: false },
    { datum: '2026-11-06', label: 'US-Arbeitsmarkt Oktober (Prognose +50–80k)', wichtig: true },
    { datum: '2026-11-10', label: 'US-CPI Oktober', wichtig: true },
    { datum: '2026-11-17', label: 'Nvidia Q3 FY27 — Entscheidung für Chips', wichtig: true },
    { datum: '2026-11-25', label: 'US-BIP Q3, 2. Schätzung', wichtig: false },
    { datum: '2026-12-09', label: 'FOMC — Hike ~74% eingepreist', wichtig: true },
    { datum: '2026-12-10', label: 'US-CPI November', wichtig: true },
  ],

  quellen: [
    'CNBC Live-Blog 29./30.10.2026 (Indizes, Brent, Bitcoin), PCE/BIP- und EZB-Berichte',
    'BNN Bloomberg / AP 30.10.2026 — Tech-Ausverkauf, Intel −28.6%',
    'FactSet Earnings Insight 30.10.2026 — Fwd-KGV 18.7, Beat-Rate 82%, EPS 2026/27',
    'Yahoo Finance & stockanalysis.com — ETF-Kurse, 52W-Spannen, KGV (30.10.2026)',
    'Financhill — S&P-500-Technik (50T ~7 705, RSI 47); 200T ~7 310 eigene Berechnung aus Yahoo-Schlusskursen 30.10.',
    'Kitco 30.10.2026 — Gold, Silber',
    'FRED — VIXCLS, ICE BofA HY OAS',
    'CME FedWatch via ZeroHedge 30.10.2026; Yahoo Fed-Live-Blog 28.10.2026',
    'BlackRock Investment Institute, Weekly Commentary 12.10. und 26.10.2026',
    'dataporium.tech, AQR, Lead-Lag Report, convextrade, ClearAnk — Korrelationen',
    'Opening Bell Daily — Saisonalität und Midterm-Zyklus (1950–2025)',
    'Schaeffer’s Research, Innovator ETFs, StoneX, Capital Group — Renditen nach Korrekturen',
    'Damodaran (NYU Stern) — implizite Risikoprämie; RIA 10.10.2026',
    'MacroMicro / Benzinga — CNN Fear & Greed; AAII Sentiment Survey',
    'Yahoo Finance via yfinance — Schlusskurse, 52W-Hochs, 50/200-Tage-Linien, RSI, Marktbreite S&P 500 (30.10.2026)',
    'Nocta Daily Brief 31.10.2026; Reuters/Ahram — Hormus-Minen, Ras Tanura, US-Iran-Kontakte',
    'Eigene Szenario-Analyse mit Zweitmeinung (scenario-analyzer), 31.10.2026',
    'CBOE Daily Market Statistics (Put/Call), FINRA Margin Debt Sep 2026, Renaissance Capital 3Q26 IPO Review',
    'TraderMonty Uptrend-Dashboard (Sektor-CSV, 30.10.2026)',
  ],
}
